
export default {
    USER_ID: process.env.REACT_APP_EMAIL_KEY,
    TEMPLATE_ID:'template_fp474s7'
}
